// extracted by mini-css-extract-plugin
module.exports = {"content":"PolicyHtmlContent_content__sYEi6"};